module.exports = __webpack_public_path__ + "img/2016-12-03.64753e16.jpg";